<template>
  <div>
    <v-list flat>
      <pc-client-side-navigation-item
        id="advisorFirmAdvisorsClientNavigationItem"
        icon="pc-entity-user"
        title="Advisors"
        :selected="activeItem == 'advisoryFirmAdvisors'"
        :to="'/accounts/' + $store.state.masterAccount?.id"
        :no-tooltips="sideMenuIsExpanded"
        data-id="b576cd7903ea8abb9de842b6e74980c6"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="advisoryFirmEmailTemplatesClientNavigationItem"
        icon="pc-email"
        :icon-size="13"
        title="Advisor email templates"
        :selected="activeItem == 'advisorEmailTemplates'"
        :to="
          '/accounts/' +
          $store.state.masterAccount?.id +
          '/advisor-email-templates'
        "
        :no-tooltips="sideMenuIsExpanded"
        data-id="a97d599adc7c4a20aa5cd0bbe4b7ed48"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="advisoryFirmUserAgreementsClientNavigationItem"
        icon="pc-legal"
        :icon-size="13"
        title="User agreements"
        :selected="activeItem == 'userAgreements'"
        :to="'/accounts/' + $store.state.masterAccount?.id + '/user-agreements'"
        :no-tooltips="sideMenuIsExpanded"
        data-id="724972670e6e4aeead6f24f4dd1ffafc"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        v-if="!$store.getters.hasContextTabs"
        id="advisoryFirmReportsClientNavigationItem"
        icon="pc-workflow-taxes-department"
        :icon-size="13"
        title="Reports"
        :selected="activeItem == 'advisoryFirmReports'"
        :to="
          '/accounts/' +
          $store.state.masterAccount?.id +
          '/advisory-firm-reports'
        "
        :no-tooltips="sideMenuIsExpanded"
        data-id="cbe3d565be3b17d120912fb2ac54ca7e"
      ></pc-client-side-navigation-item>

      <pc-client-side-navigation-item
        id="advisoryFirmAccountClientNavigationItem"
        icon="pc-settings"
        title="Account details"
        :selected="activeItem == 'advisoryFirmAccount'"
        :to="
          '/accounts/' +
          $store.state.masterAccount?.id +
          '/advisory-firm-account'
        "
        :no-tooltips="sideMenuIsExpanded"
        data-id="5f5488153be37def027c1a82d1115666"
      ></pc-client-side-navigation-item>

      <pc-advisor-user-settings-navigation-item
        v-if="!$store.getters.hasContextTabs"
        :active-item="activeItem"
        :side-menu-is-expanded="sideMenuIsExpanded"
      ></pc-advisor-user-settings-navigation-item>
    </v-list>
  </div>
</template>

<script>
import Account from "@/shared/lib/client-sdk/models/account";
import PcClientSideNavigationItem from "@/client/components/layout/PcClientSideNavigationItem";
import PcAdvisorUserSettingsNavigationItem from "@/advisor/components/layout/PcAdvisorUserSettingsNavigationItem";

export default {
  components: {
    Account,
    PcClientSideNavigationItem,
    PcAdvisorUserSettingsNavigationItem,
  },

  props: {
    activeAccount: {
      type: Account,
      required: false,
    },
    activeItem: {
      type: String,
      required: false,
      default: "",
    },
    sideMenuIsExpanded: {
      type: Boolean,
      required: false,
      default: "",
    },
  },
};
</script>

<style lang="scss"></style>
